import { PageHeader } from "../design-system";
import { useGetAllOrgCases } from "../api/orgcases";
import AdminPanel from "../components/ui/AdminPanel";
import styles from "./page-admin.module.css";

// Admin console: all cases grouped by their owning Customer.
// useGetAllOrgCases hits GET /orgs/cases, which now returns [{ customer, case }].
export default function AdminPage() {
  const { data: customerCases, error, isLoading } = useGetAllOrgCases();
  return (
    <div className={styles.page}>
      <PageHeader
        title="Administration Console"
        subtitle="Cases grouped by customer — monitor stats and start/stop case databases."
      />
      <AdminPanel customerCases={customerCases} isLoading={isLoading} error={error} />
    </div>
  );
}
